<template>
  <footer>
    <div class="to-top">
      <b-button id="pagetop" v-on:click="scrollToTop" v-bind:class="{ displayNone: showPageBtn === false }"><font-awesome-icon  :icon="['fas', 'caret-up']"></font-awesome-icon></b-button>
    </div>
    <div v-if="footerLinkCSV" class="light">
      <div class="container">
        <ul>
          <li v-bind:key="link.title" v-for="link in footerLinkCSV">
            <a v-bind:href="`${ link.url }`" target="_blank">{{ link.title }}</a>
            <img src="../../assets/images/icn-blank.png" alt="Open with a new window."/>
          </li>
        </ul>
      </div>
    </div>
    <div class="dark">
      <div class="container">
        Copyright © WEST JAPAN RAILWAY COMPANY all rights reserved. このサイトに掲載されている情報はJR西日本が提供しております。
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'site-footer',
  created () {
    this.$store.dispatch('externalData/footerLinkCSV')
  },
  mounted () {
    document.getElementById('pagetop').style.right = ((window.innerWidth - 970) / 2 - 70) + 'px'
  },
  computed: {
    ...mapState('externalData', {
      footerLinkCSV: state => state.footerLinkCSV
    }),
    ...mapState('scroll', {
      showPageBtn: state => state.showPageBtn
    })
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../css/variables';
footer {
  .to-top {
    height: 70px;
    padding-right: 40px;
    text-align: right;
    #pagetop {
      position: fixed;
      bottom: 100px;
      color: white;
      background-color: black;
      border-radius: 0;
      &.displayNone {
        display: none;
      }
    }
  }
  .light {
    background-color: $footer-light-back;
    height: 86px;
    padding-top: 33px;
  }
  .dark {
    background-color: $footer-dark-back;
    height: 80px;
    color: white;
    padding-top: 30px;
  }
  ul {
    list-style: none;
    padding-left: 0px;
    li {
      display: inline-block;
      font-weight: 600;
      img {
        width: 12px;
        height: 10px;
      }
      &:after {
        display: inline-block;
        padding-left: 20px;
        padding-right: 20px;
        content: '|';
      }
      &:last-child:after {
        display: none;
      }
      a {
        color: $text-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/SiteFooter.vue